module.exports = __webpack_public_path__ + "img/sunlei.c97fef42.png";